import Vue from "vue";
import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

/**
 * Module which provides an authorization state throughtout the application
 */
@Module
export default class AuthorizationModule extends VuexModule {
  // 📦 The authorization token that should be persisted
  public authorizationToken: string = "";

  // 🚩 Flag for whether the current user is authorized
  public isAuthorized: boolean = false;

  // 🚩 Flag for whether the 2FA is enabled
  public is2FAEnabled: boolean = false;

  // 📦 The secret question of the user
  public secretQuestion: string | null = null;

  /**
   * 👾 Updates the current value of the authorization token
   * @param newToken - the new value that should be assigned to the authorization token
   */
  @Mutation
  public SET_AUTHORIZATION_TOKEN(newToken: string) {
    this.authorizationToken = newToken;
  }

  /**
   * 👾 Updates the authorization flag for the current user
   * @param isAuthorized
   */
  @Mutation
  public SET_IS_AUTHORIZED(isAuthorized: boolean) {
    this.isAuthorized = isAuthorized;
  }

  /**
   * 👾 Sets the state for whether the 2FA is enabled by the user
   * @param is2FAEnabled
   */
  @Mutation
  public SET_2FA_ENABLED(is2FAEnabled: boolean) {
    this.is2FAEnabled = is2FAEnabled;
  }

  /**
   * 👾 Sets the secret question of the user
   * @param secretQuestion
   */
  @Mutation
  public SET_SECRET_QUESTION(secretQuestion: string) {
    this.secretQuestion = secretQuestion;
  }

  /**
   * 🚀 Fetches whether the user has 2FA enabled for their account from the API
   */
  @Action
  public fetch2FAEnabled() {
    Vue.prototype.$api.get("/api/v1/token/otp/enable").then((response: any) => {
      this.context.commit("SET_2FA_ENABLED", response.data.enabled);
    });
  }

  /**
   * 🚀 Fetches the user's secret question from the API
   */
  @Action
  public fetchSecretQuestion() {
    Vue.prototype.$api
      .get("/api/v1/token/otp/secret_question")
      .then((response: any) =>
        this.context.commit(
          "SET_SECRET_QUESTION",
          response.data.secret_question
        )
      );
  }

  @Action
  public changeAuthorizationFlag(isAuthorized: boolean) {
    this.context.commit("SET_IS_AUTHORIZED", isAuthorized);
  }
}
